<template>
  <v-card
    color="#385F73"
    dark
  >
    <v-card-title class="title py-0"> {{activePlace ? activePlace.name : ''}}</v-card-title>
    <v-card-subtitle class="pt-2 pb-0">
          <span class="grey--text text--lighten-1" v-if="!editNotes">{{ activePlace && activePlace.notes ? activePlace.notes : 'Add notes here' }}</span>
          <v-icon small v-if="!editNotes && listOwner" @click="handleEditNotes" class="ml-1 mb-1">edit</v-icon>
          <span class="grey--text text--lighten-1" v-if="editNotes && listOwner"><v-text-field dense hide-details height="28" class="pt-0 mt-0" v-model="notes" @change="updatePlace({place: activePlace, notes:notes}); editNotes=false" @blur="editNotes=false" autofocus></v-text-field></span>
    </v-card-subtitle>
    <v-card-actions class="">
      <v-btn :disabled="!activePlace.url" :href="activePlace.url" target="_blank" text small>Open In Google Maps</v-btn>
      <v-spacer></v-spacer>
      <v-icon :color="activePlace.like ? 'green' : ''" @click="listOwner ? updatePlace({place: activePlace, like: true}): ''">arrow_upward</v-icon>
      <v-icon :color="activePlace.like == false ? 'red' : ''" class="mr-4" @click="listOwner ? updatePlace({place: activePlace, like: false}): ''">arrow_downward</v-icon>
      <v-icon v-if="listOwner" small @click="deletePlace(activePlace)">delete</v-icon>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
export default {
  props: ['activePlace'],
  data: () => ({
    editNotes: false,
    notes: 'Add notes here',
  }),
  methods: {
    ...mapActions(['deletePlace', 'updatePlace']),
    handleEditNotes() {
      if (this.listOwner) {
        this.editNotes=true; 
        this.notes=this.activePlace.notes;
      }
    },
  },
  computed: {
    ...mapState(['list', 'user']),
    listOwner() {
      var x = this.list ? this.list.get('createdBy') : null;
      if (this.user && x && x.id === this.user.id) return true
      return false
    },
  },
  watch: {
  }
};
</script>
